export function MailChimpSettingsCtrl ($scope, $window, $state, $translate, API, settings, workshopAPI, messages, confirm) {
  $scope.loaded = true;
  
  $scope.lists    = [];
  $scope.settings = settings;
  
  $scope.authorize = function () {
    $window.location.assign(`${API.url}/mailchimp/auth_mailchimp`);
  };
  
  $scope.getLists = function () {
    return workshopAPI.get('/mailchimp/get_mailchimp_lists').then(function (data) {
      $scope.lists = data;
    }).catch(err => {
      messages.error(err);
    });
  };
  
  $scope.sync = function () {
    workshopAPI.get('/mailchimp/mailchimp_batch_upload', $scope.settings.mailchimp_settings.list.id).then(function (data) {
      messages.show($translate.instant('JS_SPACE.MAILCHIMP.SYNC_MESSAGE'), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };
  
  $scope.unauthorize = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.UNAUTHORISE', { name: 'MailChimp' })).then(() => {
      return workshopAPI.get('/company/remove_mailchimp');
    }).then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.UNAUTHORISED', { name: 'MailChimp' }), 'success');

      $state.reload();
    }).catch(err => {
      messages.error(err);
    });
  };
  
  if ($scope.settings.has_mailchimp) {
    $scope.getLists();
  }
}